import Tabs from '@/js/tabs.js';

class BrewersNotes extends Tabs {}

customElements.get('brewers-notes-js-tabs') ||
  customElements.define('brewers-notes-js-tabs', BrewersNotes);
